export default "<ion-app class=\"notranslate\">\n  <app-loading *ngIf=\"showLoading\"></app-loading>\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>\n";